const MX = {
  countryConfig: {
    accountHolderDocNumber: {
      label: "bankDetails.accountHolderDocNumber",
      placeholder: "bankDetails.documentCedulaPlaceholderMx",
      visible: true,
      required: true,
    },
    CLABE: {
      visible: true,
      label: "bankDetails.CLABE",
      placeholder: "bankDetails.CLABEPlaceholderMx",
      required: true,
    },
    swift: {
      required: true,
      visible: true,
      label: "bankDetails.swift",
      placeholder: "bankDetails.swiftMinmaxValidation",
    },
    IBAN: {
      visible: false,
    },
    accountNumber: {
      visible: false,
      required: false,
      label: "bankDetails.accountNumber",
    },
    bankAddress: {
      visible: false,
      required: false,
    },
    bankName: {
      visible: true,
      label: "bankDetails.bankName",
      required: true,
    },
  },
};
export { MX };
